module.exports = __webpack_public_path__ + "img/icon_kefu_black.824f09b2.png";